import { render, staticRenderFns } from "./VoteDetailDialog.vue?vue&type=template&id=044d5601&scoped=true"
import script from "./VoteDetailDialog.vue?vue&type=script&lang=js"
export * from "./VoteDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteDetailDialog.vue?vue&type=style&index=0&id=044d5601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d5601",
  null
  
)

export default component.exports